import CommonService from './common';
import { WEB_SSO } from '../../../utils/urls';
import { encryptParams } from '../../../utils/index';

export default class PasswordService extends CommonService {
  // /**
  //  * [get mobile verification code] out-of-date
  //  * @param {string} mobile the mobile used to login
  //  * @return {Promise} send result
  //  */
  // public sendMobileCode(params: { mobile: string }): Promise<any> {
  //   return this.baseSendMobileCode({
  //     ...params,
  //     type: 6,
  //   });
  // }

  /**
   * [get mobile verification code V2]
   * @param {string} mobile the mobile used to login
   * @param {string} check_register whether need to check register
   * @return {Promise} send result
   */
  public sendMobileCodeV2 = (params: {
    mobile: string;
    check_register?: boolean;
    extra_params?: object;
  }): Promise<any> => {
    let { mobile, check_register = false, extra_params = {} } = params;
    return this.baseSendMobileCodeV2({
      mobile,
      type: check_register ? 4 : 6,
      ...extra_params,
    });
  };

  // /**
  //  * [send a verification url to email] out-of-date
  //  * @param {string} email email
  //  * @param {string} next redirect url after login success
  //  * @param {string} password password
  //  */
  // public sendEmailCode(params: {
  //   email: string;
  //   next?: string;
  //   password?: string;
  // }): Promise<any> {
  //   let { email, password, ...extra_params } = params;
  //   const data = encryptParams(
  //     { email, password, ect_type: 4, ...extra_params },
  //     ['email', 'password']
  //   );
  //   return new Promise((resolve, reject) => {
  //     this.request({
  //       url: WEB_SSO.SSO_EMAIL_ACTIVATE_CODE_URL,
  //       method: 'POST',
  //       data,
  //     })
  //       .then((data: any) => {
  //         resolve(data);
  //       })
  //       .catch((e: any) => {
  //         reject(e);
  //       });
  //   });
  // }

  /**
   * [send a verification url to email V2]
   * @param {string} email email
   * @param {string} next redirect url after login success
   * @param {string} password password
   */
  public sendEmailCodeV2 = (params: {
    email: string;
    next?: string;
    password?: string;
    extra_params?: object;
  }): Promise<any> => {
    const { extra_params = {}, ...rest } = params;
    return this.baseSendEmailCodeV2({
      ...rest,
      ect_type: 4,
      ...extra_params,
    });
  };

  /**
   * [reset password]
   * @param {string} account account
   * @param {string} code verify code
   * @param {string} password new password
   */
  public resetPassword = (params: {
    account: string;
    code: string;
    password: string;
    extra_params?: object;
  }): Promise<any> => {
    let { account, code, password, extra_params = {} } = params;
    const data = encryptParams({ account, code, password }, [
      'account',
      'code',
      'password',
    ]);
    return new Promise((resolve, reject) => {
      this.request({
        url: WEB_SSO.RESET_PASSWORD,
        method: 'POST',
        data: {
          ...data,
          ...extra_params,
        },
      })
        .then((data: any) => {
          resolve(data);
        })
        .catch((e: any) => {
          reject(e);
        });
    });
  };

  /**
   * [modify password by email code]
   * @param email
   * @param code
   * @param password
   * @param extra_params
   * @returns
   */
  public resetPasswordByEmailCode = (params: {
    email: string;
    code: string;
    password: string;
    extra_params?: object;
  }): Promise<any> => {
    let { email, code, password, extra_params = {} } = params;
    const data = encryptParams({ email, code, password }, [
      'email',
      'code',
      'password',
    ]);
    return this.request({
      url: WEB_SSO.RESET_PASSWORD_BY_EMAIL,
      method: 'POST',
      data: {
        ...data,
        ect_type: 4,
        ...extra_params,
      },
    });
  };

  /**
   * [send a verification url to email V2]
   * @param {string} email email
   * @param {string} next redirect url after login success
   * @param {string} password password
   */
  public sendEmailCodeModifyPassword = (
    params: {
      email?: string;
      next?: string;
      password?: string;
      email_logic_type?: number;
      extra_params?: object;
    } = {}
  ): Promise<any> => {
    const { extra_params = {}, ...rest } = params;
    return this.baseSendEmailCodeV2({
      ...rest,
      ect_type: 11,
      ...extra_params,
    });
  };

  /**
   * [modify password by email code]
   * @param email
   * @param code
   * @param password
   * @param extra_params
   * @returns
   */
  public modifyPasswordByEmailCode = (params: {
    email?: string;
    code: string;
    password: string;
    extra_params?: object;
  }): Promise<any> => {
    let { email, code, password, extra_params = {} } = params;
    const data = encryptParams({ email, code, password }, [
      'email',
      'code',
      'password',
    ]);
    return this.request({
      url: WEB_SSO.RESET_PASSWORD_BY_EMAIL,
      method: 'POST',
      data: {
        ...data,
        ect_type: 11,
        ...extra_params,
      },
    });
  };

  /**
   * [登录态下设置密码]
   * @param password
   * @param extra_params
   * @returns
   */
  public setPassword = (params: {
    password: string;
    extra_params?: object;
  }): Promise<any> => {
    let { password, extra_params = {} } = params;
    const data = encryptParams({ password }, ['password']);
    return this.request({
      url: WEB_SSO.SET_PASWORD,
      method: 'POST',
      data: {
        ...data,
        ...extra_params,
      },
    });
  };
}
